import { cn } from '@bem-react/classname';

export const cnText = cn('Text');
